module.exports = __webpack_public_path__ + "images/bfc060a0a5f116ef4bc705701cd038e4.png";